import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	ReactTemplateSymbol,
	ESMLoaderSymbol,
	PromiseCacheSymbol,
	ImportMapSymbol,
	EsModuleShimsRuntimeStateSymbol,
} from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactory } from './esmLoaderFactory'
import { PromiseCache } from './promiseCache'
import { ImportMapFactory } from './importMapFactory'
import { PublicAppWillMountHandler } from './publicAppWillMountHandler'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { EsModuleShimsRuntimeStateFactory } from './esModuleShimRuntimeState'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(PromiseCacheSymbol).to(PromiseCache)
	bind(ImportMapSymbol).to(ImportMapFactory)
	bind(ESMLoaderSymbol).to(ESMLoaderFactory)
	bind(LifeCycle.AppWillMountHandler).to(PublicAppWillMountHandler)
	bind(EsModuleShimsRuntimeStateSymbol).to(EsModuleShimsRuntimeStateFactory)
}

// Export symbols and types for use by other features
export { ESMLoaderSymbol, ImportMapSymbol } from './symbols'
export type { ImportMap } from './types'
